import { render, staticRenderFns } from "./PatientPeriod.vue?vue&type=template&id=6bbd22ee&scoped=true"
import script from "./PatientPeriod.vue?vue&type=script&lang=js"
export * from "./PatientPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbd22ee",
  null
  
)

export default component.exports